<template>
  <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 200] }"
      class="elevation-12"
      dense
  >
    <template v-slot:top>
      <div class="px-4">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-select v-model="filters.region"
                      :items="$store.getters.appLogin.regions"
                      :item-value="item => item"
                      :item-text="item => item.name"
                      label="Область"
                      :clearable="true"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete v-model="filters.area"
                            :items="sortedAreas"
                            :item-value="item => item"
                            :item-text="item => item.name"
                            label="Район"
                            :clearable="true"
                            @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6">
            <v-text-field v-model="filters.address" label="Адрес" @keyup.enter="onRefreshButtonClicked"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="d-flex align-center justify-center justify-md-end">
            <v-btn x-large color="primary" dark @click="onRefreshButtonClicked">Обновить</v-btn>
          </v-col>
        </v-row>
      </div>
    </template>

    <template v-slot:item="scope">
      <tr>
        <td class="text-center">{{ scope.item.displayNumber }}</td>
        <td class="text-center">{{ scope.item.region }}</td>
        <td class="text-center"> {{ scope.item.area }}</td>
        <td class="text-center">{{ scope.item.address }}</td>
        <td class="text-center">{{ scope.item.postCode }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from "underscore";
import $store from "@/store"

export default {
  name: "PostIndexesDatatable",
  props: {
    postIndexes: {
      type: Array,
      default: () => {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        sortBy: ['createdOn'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 10,
      },
      filters: {
        region: this.$store.getters.appLogin.regions[0],
        area: this.$store.getters.appLogin.areas[0],
        address: '',
      }
    };
  },
  computed: {
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.postIndexes, pp => {
        pp.displayNumber = skip + (number++)
        return pp
      })
    },
    sortedAreas(){
      var selectedRegionId = this.filters.region?.id;
      if(selectedRegionId > 0){
        return $store.getters.appLogin.areas.filter(item => item.region?.id === selectedRegionId)
      }
      else{
        return $store.getters.appLogin.areas;
      }
    }
    ,
    headers() {
      const headers = []

      headers.push({
        text: '№',
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: 'Область',
        align: 'center',
        sortable: false,
        value: 'region'
      })

      headers.push({
        text: 'Район',
        align: 'center',
        sortable: false,
        value: 'area'
      })

      headers.push({
        text: 'Адрес',
        align: 'center',
        sortable: false,
        value: 'address'
      })

      headers.push({
        text: 'Пост индекс',
        align: 'center',
        sortable: false,
        value: 'postCode'
      })

      return headers
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    }
  },
  methods: {
    updateItems() {
      this.$emit("update", this.options, this.filters)
    },
    onFiltersChanged() {
      if (this.options.page !== 1)
        this.options.page = 1;
      else
        this.updateItems();
    },
    onAddressInputDebounce: _.debounce(function(){
      this.updateItems()
    }, 500),
    onRefreshButtonClicked() {
      this.updateItems();
    },
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  }
}
</script>

<style scoped>

</style>
